import React, { useState } from 'react';
import useGlobal from '../../../store';

const PriceMatchesTableHeader = () => {
  const [globalState] = useGlobal();
  const { text } = globalState;

  const [headerFields] = useState({
    more_info: 'desktop',
    status: 'desktop',
    order: 'desktop',
    created_at: '',
    sku_count: 'desktop',
    refunded: '',
    channel: ''
  });

  const headList = Object.keys(headerFields).map(field => {
    return (
      <div
        className={
          headerFields[field] === 'desktop' ? 'objects-table__item__cell' : 'objects-table__item__cell desktop'
        }
        key={field}
      >
        {text.objects_table[field]}
      </div>
    );
  });

  return <li className="price-match__item has-text-weight-bold">{headList}</li>;
};

export default PriceMatchesTableHeader;
